import { LOCAL_STORAGE_KEYS } from "@command-center-app/constants/common.const";
import axiosService from "./axios.service";
import { API_ROUTES } from "@command-center-app/constants/api.const";
import appRoutes from "@command-center-app/constants/app.routes.const";
import { IAuthUser, PostLogin } from "..";

export const sendMagicLink = async (email: string) => {
  return await axiosService.post(API_ROUTES.SEND_MAGIC_LINK, { email });
};

export const verifyMagicLink = async (token: string) => {
  return await axiosService
    .post(API_ROUTES.VERIFY_MAGIC_LINK, { token })
    .then((resp) => resp.data);
};

export const authenticateLoggedInUser = async () => {
  return (await axiosService.get(API_ROUTES.GET_USER_INFO)).data;
};

export const logoutUser = async () => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.JWT_TOKEN);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_DATA);
};

export const validateAuthentication = async (
  navigate: any
): Promise<PostLogin | undefined> => {
  if (localStorage.getItem(LOCAL_STORAGE_KEYS.JWT_TOKEN)) {
    try {
      const authUser = await authenticateLoggedInUser();
      if (authUser) {
        localStorage.setItem(
          LOCAL_STORAGE_KEYS.USER_DATA,
          JSON.stringify(authUser.data)
        );
        return {
          authToken: localStorage.getItem(LOCAL_STORAGE_KEYS.JWT_TOKEN) || '',
          userData: authUser.data,
        };
      }
    } catch (err) {
      console.error(err);
      logoutUser();
      navigate(appRoutes.LOGIN);
    }
  } else {
    return {
      authToken: "",
      userData: null
    }
  }
};

export const saveDataPostLogin = (response: {
  authToken: string;
  userData: any;
}): PostLogin => {
  const { authToken, ...userData } = response;
  localStorage.setItem(LOCAL_STORAGE_KEYS.JWT_TOKEN, authToken);
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_DATA, JSON.stringify(userData));
  return { authToken, userData: userData as any as IAuthUser };
};
